import Lightbox from './Lightbox';
import 'slick-carousel';
import arrow from '!svg-inline-loader!../Images/Arrow_events.svg';
import debounce from 'lodash.debounce';

const lightbox = new Lightbox();

const browserScrollbarWidth =
  window.innerWidth != null
    ? window.innerWidth - document.documentElement.clientWidth
    : 0;

const baseConfig = {
  dots: false,
  autoplay: false,
  pauseOnHover: true,
  prevArrow: `<div class="slick-prev">${arrow}</div>`,
  nextArrow: `<div class="slick-next">${arrow}</div>`,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  centerMode: false,
  variableWidth: true,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 769 + browserScrollbarWidth,
      settings: {
        slidesToShow: 1,
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
  ],
};

// Uses max-width: 100% and just shows as many items as possible
const mediaConfig = {
  ...baseConfig,
  responsive: 'none',
};

// Size will be defined over bootstrap col in order to function responsively
const agendaConfig = {
  ...baseConfig,
  responsive: 'none',
};

// Size will be defined over bootstrap col in order to function responsively
const personConfig = {
  ...baseConfig,
  responsive: 'none',
};

const testimonialConfig = {
  ...baseConfig,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
};

const apartmentConfig = {
  ...baseConfig,
};

// Uses max-width: 100% and just shows as many items as possible
const fiveReasonsConfig = {
  ...baseConfig,
  responsive: 'none',
  adaptiveHeight: true,
};

const logoConfig = {
  ...baseConfig,
  responsive: 'none',
};

const accordionConfig = {
  ...baseConfig,
  responsive: 'none',
};

// Get slider elements
const $mediaSliders = $('.Slider--MediaItem');
const $agendaSliders = $('.Slider--News, .Slider--Events');
const $personSliders = $('.Slider--Person');
const $testimonialSliders = $('.Slider--Testimonial');
const $fiveReasonsSliders = $('.Slider--FiveReasons');
const $logoSliders = $('.Slider--Logo');
const $accordionSlider = $('.Slider--Accordion');

// Add sliders that should get the responsive bootstrap styles
const $slidersForResponsive = [
  $agendaSliders,
  $personSliders,
  $accordionSlider,
];

// Custom logic for sliders to not be sliders if they don't clip outside their container
function deactivateFullyVisibleSliders() {
  $('.Slider').each((index, element) => {
    const $element = $(element);

    const slideWidths = $element
      .find('.Slider__Slide')
      .toArray()
      .map(function (el) {
        return $(el).width();
      });
    if (!slideWidths) {
      return;
    }

    const slideWidthsSum = slideWidths.reduce(function (acc, cur) {
      return acc + cur;
    }, 0);

    const parentWidth = $element.parent().width();

    if (slideWidthsSum <= parentWidth) {
      $element.slick('slickSetOption', 'slidesToShow', 999, true);
    } else {
      const slideWidth = slideWidths[0];
      let fitCount = Math.floor(parentWidth / slideWidth);
      if (fitCount < 1) fitCount = 1;
      $element.slick('slickSetOption', 'slidesToShow', fitCount, true);
    }
  });
}

/**
 * Custom handling for mobile testimonials
 */
function initTestimonial($slider) {
  $slider.find('.Testimonial__Text').on('click touch', (event) => {
    const $testimonialText = $(event.currentTarget);

    $testimonialText.parents('.Testimonial--Slider').toggleClass('showFull');
  });
}

/**
 * Custom adding bootstrap cols to slick slider
 */
function makeSlidersResponsiveAgain($sliders) {
  $sliders.forEach(function (element) {
    const colClasses =
      element.data('slider-slide-col-classes') || 'col-12 col-md-6 col-lg-4';
    element.find('.slick-list').addClass('row row--big');
    element.find('.slick-slide').addClass(colClasses + ' column');
  });
}

/**
 * Custom handling of lightcase for slider items
 */
function initMediaItem($slider) {
  $slider.find('.MediaItem__Link').each((index, element) => {
    const $element = $(element);

    let currentlyClicking = false;

    let screenX = 0;
    let moveCounter = 0;

    /**
     * open lightcase in case of a click not caused by a human
     * this is necessary for the lightcase navigation to work
     */
    $element.on('click touch', (event) => {
      event.preventDefault();

      if (event.originalEvent) {
        return;
      }

      $element.lightcase('start', { ...lightbox.config });
    });

    // Initialize click / touch
    $element.on('touchstart mousedown', (event) => {
      screenX = event.screenX;
      currentlyClicking = true;
      moveCounter = 0;
    });

    // Keep track of how how far the user moves before releasing
    $element.on('touchmove mousemove', (event) => {
      moveCounter += 1;
    });

    // If, as far as we can tell, the click / touch was intended to open the lightbox, do so
    $element.on('touchend mouseup', (event) => {
      // Ignore those that didn't start inside the item
      if (!currentlyClicking) {
        return;
      }

      currentlyClicking = false;

      // Ignore those that registed a certain amount of movement
      if (moveCounter > 5) {
        return;
      }

      // Ignore those that registed a certain amount of distance moved (only works with mouse, not touch)
      if (Math.abs(event.screenX - screenX) > 30) {
        return;
      }

      $element.lightcase('start', lightbox.config);
    });
  });
}

/**
 * Custom handling for news / event slider items
 */
function initAgendaItems($slider) {
  $slider.find('.AgendaItem').height('auto');

  requestAnimationFrame(() => {
    if ($slider.slick('slickGetOption', 'variableWidth')) {
      const maxHeight = $slider
        .find('.AgendaItem')
        .toArray()
        .reduce(function (acc, cur) {
          return Math.max($(cur).height(), acc);
        }, 0);

      $slider.find('.AgendaItem').height(`${maxHeight}px`);
    }
  });
}

class SliderPageCounter {
  state = {
    slide: 0,
  };

  constructor(sliderEl) {
    this.$slider = $(sliderEl);
    this.slick = this.$slider.slick('getSlick');
    this.state.slide = this.slick.currentSlide;
    this.createElements();
    this.addEventHandlers();
    this.update();
  }

  createElements() {
    this.$currentPage = $(
      '<span class="Slider__CurrentPage Slider__PageCounterLabel" />'
    );
    this.$pageCount = $(
      '<span class="Slider__PageCount Slider__PageCounterLabel" />'
    );
    this.$rootEl = $('<div class="Slider__PageCounter"></div>').append([
      this.$currentPage,
      $(
        '<span class="Slider__PageCounterSeparator Slider__PageCounterLabel">/</span>'
      ),
      this.$pageCount,
    ]);
  }

  lastPageCount = null;

  updateMount(pageCount, remount) {
    if (!remount && this.lastPageCount === pageCount) {
      return;
    }

    if (pageCount > 1) {
      // the slick-list will be recreated by slick slider so we cannot cache its jquery reference
      this.$slider.append(this.$rootEl);
    } else {
      this.$rootEl.detach();
    }

    this.lastPageCount = pageCount;
  }

  update(remount) {
    const pageCount = this.getPageCount();
    this.updateMount(pageCount, remount);
    this.$currentPage.text(this.state.slide + 1);
    this.$pageCount.text(pageCount);
  }

  onBeforeChange = (event, slick, currentSlide, nextSlide) => {
    this.state.slide = nextSlide;
    this.update();
  };

  getPageCount() {
    return (
      Math.max(this.slick.slideCount - this.slick.options.slidesToShow, 0) + 1
    );
  }

  addEventHandlers() {
    this.$slider.on('beforeChange', this.onBeforeChange);
  }
}

let pageCounters = [];
$(() => {
  // Init slick
  $mediaSliders.slick({ ...mediaConfig });
  $agendaSliders.slick({ ...agendaConfig });
  $personSliders.slick({ ...personConfig });
  $testimonialSliders
    .slick({ ...testimonialConfig })
    .on('breakpoint', (e) => initTestimonial($(e.currentTarget)));
  $fiveReasonsSliders.slick({ ...fiveReasonsConfig });
  $logoSliders.slick({ ...logoConfig });
  $accordionSlider.slick({ ...logoConfig });

  // Init slider items that need manual tinkering
  $testimonialSliders.each((i, e) => initTestimonial($(e)));
  $mediaSliders.each((i, e) => initMediaItem($(e)));
  $fiveReasonsSliders.each((i, e) => initMediaItem($(e)));
  $logoSliders.each((i, e) => initMediaItem($(e)));

  makeSlidersResponsiveAgain($slidersForResponsive);
  deactivateFullyVisibleSliders();

  $('.Slider').each(function () {
    pageCounters.push(new SliderPageCounter(this));
  });
});

const updatePageCounter = function (counter) {
  counter.update(true);
};
$(window).resize(
  debounce(function () {
    makeSlidersResponsiveAgain($slidersForResponsive);
    deactivateFullyVisibleSliders();
    pageCounters.forEach(updatePageCounter);
  }, 200)
);
